import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";

@Component({
    selector: "app-root",
    imports: [RouterModule, MatProgressSpinnerModule],
    template: `
        <router-outlet (activate)="isLoading = false" />
        @if (isLoading) {
            <div class="loading">
                <mat-spinner />
            </div>
        }
    `,
    styles: [
        `
            .loading {
                position: absolute;
                top: 0;
                left: 0;
                height: 100vh;
                width: 100vw;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent {
    public isLoading = true;
}
